<template lang="pug">
    #navbar.elevation-4
        //- DESKTOP NAVIGATION
        nav.desktop-nav.hide-on-med-and-down
            section
                router-link(to='/', :class="brandImageTheme").logo
                    img(:src="$store.state.logo" :class="$store.state.defaultLogo ? 'default-logo' : '' " )
                ul.navigation
                    li.nav-dropdown(v-if="projectId" :class="isMonitorGroupActive ? 'active' : ''")
                        v-menu(offset-y bottom content-class="desktop-nav-dropdown" transition="slide-y-transition")
                            template(v-slot:activator="{ on, attrs }")
                                a.nav-dropdown-trigger(href="#" v-bind="attrs" v-on="on" @click.prevent)
                                    | Monitor
                                    v-icon.nav-dropdown-caret(small) mdi-menu-down
                            v-list
                                v-list-item(:to="monitorStandardTo" :class="tab == 'monitor' ? 'active' : ''") Standard
                                v-list-item(:to="dashboardsTo" :class="tab == 'dashboard' ? 'active' : ''") Dashboards
                                v-list-item(:to="heatMapTo" :class="tab == 'heatmaps' ? 'active' : ''") Heat Map
                    li(v-if="projectId && projectId != 'pwNeghwfDaNcSlOApelIYmA6'" :class="tab == 'kiosks' ? 'active' : ''")
                        router-link(:to="kiosksTo") Kiosks
                    li(v-if="((userRole === 'admin' || userRole === 'superAdmin') && projectId)" :class="tab == 'devices' ? 'active' : ''")
                        router-link(:to="devicesTo") Devices
                    li(v-if="projectId" :class="tab == 'reports' ? 'active' : ''")
                        router-link(:to="reportsTo") Reports
                    li(v-if="projectId" :class="tab == 'alerts' ? 'active' : ''")
                        router-link(:to="alertsTo") Alerts
                    li(v-if="projectId && canBeScheduled" :class="tab == 'schedules' ? 'active' : ''")
                        router-link(:to="schedulesTo") Schedules
                    li(v-if="projectId" :class="tab == 'explorer' ? 'active' : ''")
                        router-link(:to="pointExplorerTo") Point Explorer
                    li(v-if="((userRole === 'admin' || userRole === 'superAdmin') && projectId)" :class="tab == 'virtualedge' ? 'active' : ''")
                        router-link(:to="virtualEdgeTo")
                            | Virtual Edge
                            span.nav-new-badge New
                    li(v-if="showAiChatNav" :class="tab == 'aichat' ? 'active' : ''")
                        router-link(:to="aiChatTo")
                            | AI Chat
                            span.nav-new-badge New
            section.user-section
                .nav-icons
                    .nav-icon
                        v-icon.theme-toggle(@click="toggleTheme") mdi-invert-colors
                    .nav-icon(v-if="scoreHelp")
                        v-icon.score-help(@click="activeDialog='scorehelp'") mdi-help-circle-outline
                    .nav-icon(v-if="siteId")
                        .haq-alerts
                            //- .alerts-notification(v-if="notifications" :class="notifications.cssClass")
                            v-icon.alerts(@click="activeDialog='alerts'" :class="notifications.cssClass") mdi-bell
                .v-divide
                .user-info(v-if="$store.state.user")
                    .user-name {{firstName}} {{lastName}}
                    .user-role {{userRole}}
                v-menu(content-class="desktop-user-settings" offset-y transition="slide-y-transition" bottom)
                    template(v-slot:activator="{ on, attrs }")
                        .avatar-wrapper(v-bind="attrs" v-on="on")
                            img.avatar(:src="profilePhoto ? profilePhoto : '/images/ssprofile.png'")
                    v-list
                        v-list-item.modal-trigger(href="#modal-project-select") Change Project
                        v-list-item(v-if="site && (site.commanderLicenseId || (site.project && site.project.commanderLicenseId))" @click="openInCommander()") Open in Commander
                        v-list-item(v-if="userRole === 'admin' || userRole === 'superAdmin'" @click="openAdminDashboard") Open Portfolio Manager
                        v-list-item(v-if="userRole === 'admin' || userRole === 'superAdmin'" @click="openAlertRelay") Open Alert Relay
                        v-list-item(v-if="showLibraryNav" :to="libraryTo") Library
                        v-list-item.h-divide
                        v-list-item(to='/settings')
                            v-icon mdi-cog
                            span Settings
                        v-list-item(href="/logout")
                            v-icon mdi-logout
                            span Log Out
        //- MOBILE NAVIGATION
        nav.mobile-nav.hide-on-large-only
            section
                router-link(to='/', :class="brandImageTheme").logo
                    img(:src="$store.state.logo" :class="$store.state.defaultLogo ? 'default-logo' : '' " )
            section
                .nav-icons
                    .nav-icon(v-if="scoreHelp")
                        v-icon.score-help(@click="activeDialog='scorehelp'") mdi-help-circle-outline
                    .nav-icon(v-if="siteId")
                        .haq-alerts
                            //- .alerts-notification(v-if="notifications" :class="notifications.cssClass")
                            v-icon.alerts(@click="activeDialog='alerts'" :class="notifications.cssClass") mdi-bell
                    .nav-icon
                        v-icon.mobile-drawer-trigger(@click.stop="drawer = !drawer") mdi-menu
        //- MOBILE DRAWER
        v-navigation-drawer.mobile-drawer(v-model="drawer" absolute temporary)
            template(v-slot:prepend)
                v-list-item.user-profile(two-line)
                    v-list-item-avatar.user-img(v-if="$store.state.user")
                        img(:src="profilePhoto ? profilePhoto : '/images/ssprofile.png'")
                    v-list-item-content.user-info(v-if="$store.state.user")
                        v-list-item-title.user-name {{firstName}} {{lastName}}
                        v-list-item-subtitle.user-role {{userRole}}
                    v-btn(icon @click.stop="drawer = !drawer")
                        v-icon mdi-chevron-left
            v-divider
            v-list(v-if="projectId")
                v-list-group(v-model="monitorGroupOpen" no-action)
                    template(v-slot:activator)
                        v-list-item-content
                            v-list-item-title Monitor
                    v-list-item(:class="tab == 'monitor' ? 'active' : ''" link)
                        router-link(:to="monitorStandardTo") Standard
                    v-list-item(:class="tab == 'dashboard' ? 'active' : ''" link)
                        router-link(:to="dashboardsTo") Dashboards
                    v-list-item(:class="tab == 'heatmaps' ? 'active' : ''" link)
                        router-link(:to="heatMapTo") Heat Map
                v-list-item(v-if="projectId && projectId != 'pwNeghwfDaNcSlOApelIYmA6'" :class="tab == 'kiosks' ? 'active' : ''" link)
                    router-link(:to="kiosksTo") Kiosks
                v-list-item(v-if="((userRole === 'admin' || userRole === 'superAdmin') && projectId)" :class="tab == 'devices' ? 'active' : ''")
                    router-link(:to="devicesTo") Devices
                v-list-item(v-if="projectId" :class="tab == 'reports' ? 'active' : ''")
                    router-link(:to="reportsTo") Reports
                v-list-item(v-if="projectId" :class="tab == 'alerts' ? 'active' : ''")
                    router-link(:to="alertsTo") Alerts
                v-list-item(v-if="projectId && canBeScheduled" :class="tab == 'schedules' ? 'active' : ''" link)
                    router-link(:to="schedulesTo") Schedules
                v-list-item(:class="tab == 'explorer' ? 'active' : ''" link)
                    router-link(:to="pointExplorerTo") Point Explorer
                v-list-item(v-if="userRole === 'admin' || userRole === 'superAdmin'" :class="tab == 'virtualedge' ? 'active' : ''" link)
                    router-link(:to="virtualEdgeTo")
                        | Virtual Edge
                        span.nav-new-badge New
                v-list-item(v-if="showAiChatNav" :class="tab == 'aichat' ? 'active' : ''" link)
                    router-link(:to="aiChatTo")
                        | AI Chat
                        span.nav-new-badge New
            .h-divide(v-if="projectId")
            v-list
                v-list-item.modal-trigger(href="#modal-project-select") Change Project
                v-list-item(v-if="site && (site.commanderLicenseId || (site.project && site.project.commanderLicenseId))" @click="openInCommander()") Open in Commander
                v-list-item(v-if="userRole === 'admin' || userRole === 'superAdmin'" @click="openAdminDashboard") Open Portfolio Manager
                v-list-item(@click="openAlertRelay") Open Alert Relay
                v-list-item(v-if="showLibraryNav" :to="libraryTo") Library
            template(v-slot:append)
                .h-divide
                v-list
                    v-list-item.theme-toggle(@click="toggleTheme")
                        v-list-item-icon
                            v-icon mdi-invert-colors
                        v-list-item-content
                            v-list-item-title {{currentTheme ? 'Disable Dark Thene' : 'Enable Dark Theme'}}
                .h-divide
                v-list.user-settings
                    v-list-item(to='/settings')
                        v-list-item-icon
                            v-icon mdi-cog
                        v-list-item-content
                            v-list-item-title Settings
                    v-list-item(href="/logout")
                        v-list-item-icon
                            v-icon mdi-logout
                        v-list-item-content
                            v-list-item-title Log Out

        Alerts(
            v-if="activeDialog == 'alerts'"
            :openModal="activeDialog"
            :alerts="notifications ? notifications.alerts : null"
            :site-id="siteId"
            :site="site"
            v-on:closeModal="closeModal"
        )
        ScoreHelp(v-if="activeDialog == 'scorehelp'" :openModal="activeDialog" v-on:closeModal="closeModal" :overallCurScore="scoreHelp.overallCurScore" :measurements="scoreHelp.measurements")
        ModalProjectSelect
</template>
<script>
import {wlData} from '../assets/js/constants';
import Alerts from "@/components/modals/Alerts";
import ScoreHelp from "@/components/modals/ScoreHelp";
import ModalProjectSelect from "@/components/ModalProjectSelect";
import {HTTPClient} from '../assets/js/http';
import { isAccessibleSiteId, firstAccessibleSite, sitesUserCanAccess } from '../assets/js/siteAccess';

let client = new HTTPClient();
let timeCheck = true;
let runThemeCheckOnce = false;

export default {
    name: "Navbar",
    components: {
        Alerts,
        ScoreHelp,
        ModalProjectSelect,
    },
    props: {
        siteId: String,
        zoneId: String,
        tab: String,
        site: Object,
        scoreHelp: Object,
    },
    data(){
        let {brandImageTheme} = wlData;
        return {
            // siteId: this.$route.params.siteId,
            // zoneId: this.$route.params.zoneId,
            brandImageTheme,
            drawer: false,
            navItems: [],
            activeDialog: null,
            monitorGroupOpen: false,
        };
    },
    methods: {
        closeModal() {
			this.activeDialog = null;
		},
        openInCommander(){
            if(this.site && this.site.commanderLicenseId)
                window.open('https://app.kmccommander.com/setlicense/' + this.site.commanderLicenseId, "_blank")
            else if(this.site && this.site.project && this.site.project.commanderLicenseId)
               window.open('https://app.kmccommander.com/setlicense/' + this.site.project.commanderLicenseId, "_blank")
            else
                console.warn('No commander license found for this site/project');
        },
        openAdminDashboard(){
            if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
                window.open('http://localhost:12120/', '_blank')
                return
            }
            let subdomain = location.host.split('.')[0];
            let domain = location.host.split('.')[1];
            let beta = subdomain.indexOf("beta") > -1 ? true : false;
            location = beta ? `https://betaadmin.${domain}.com/` : `https://admin.${domain}.com/`;
        },
        openAlertRelay(){
            let subdomain = location.host.split('.')[0];
            let domain = location.host.split('.')[1];
            let beta = subdomain.indexOf("beta") > -1 ? true : false;
            location = beta ? `https://betaalerts.${domain}.com/` : `https://alerts.hawkenaq.com/`;
        },
        toggleTheme(){
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
            let theme = this.$vuetify.theme.dark ? 'dark' : 'light';
            this.setTheme(theme);
        },
        setTheme(theme,customTheme){
            try{
                if(customTheme)
                    this.$store.dispatch('setCustomTheme', [theme, customTheme]);
                else if(this.projectThemes)
                    this.$store.dispatch('setCustomTheme', [theme, this.projectThemes]);
                else
                    this.$store.dispatch('setDefaultTheme', theme);

                client.robustPost('/api/theme', {theme}).catch(function(error) {
                    console.error(error);
                    window.M.toast({html : 'Cannot Save theme'});
                });
            }catch(error){
                console.error(error);
            }
        },
        async fetchAlerts(){
			try {
                if(!this.siteId) return;
                this.$store.dispatch('fetchAlerts', this.siteId);
			} catch (error) {
				console.error(error);
			}
		},
    },
    mounted() {
        try{
            if (this.isMonitorGroupActive) this.monitorGroupOpen = true;
            this.navItems = [
                {
                    title: "Monitor",
                    // icon: "mdi-view-dashboard",
                    link: '/projects/' + this.projectId + '/sites/'+ this.siteId,
                },
                {
                    title: "Projects",
                    link: "/projects"
                }
            ];
            let theme = this.$store.state.theme;
            let customTheme = this.projectThemes;
            this.setTheme(theme,customTheme);
            this.fetchAlerts();
            this.$store.dispatch('getSites').catch(function(error) {
                console.error(error);
            });

            if(!timeCheck){
                timeCheck = setInterval(() => {
                    // check for time change of theme.
                    // this only runs if the project is CPS and has light and dark themes
                    try{
                        if(this.projectId == 'T1Z1nsOdp2'){
                            let themeKeys = Object.keys(this.projectThemes);
                            if(themeKeys.indexOf('light')<0 || themeKeys.indexOf('dark')<0) return;
                            let now = new Date();

                            if(now.getHours() == 6 && now.getMinutes() == 0 && now.getSeconds() == 0){
                                // 6am
                                if(theme != 'light'){
                                    this.setTheme('light');
                                }
                            }else if(now.getHours() == 18 && now.getMinutes() == 0 && now.getSeconds() == 0){
                                // 6pm
                                if(theme != 'dark'){
                                    this.setTheme('dark');
                                }
                            }
                            if(!runThemeCheckOnce){
                                // these should only be run on initialization, to set the theme correctly if the user is just loading the page mid day
                                if(now.getHours() >= 6 && now.getHours() < 18){
                                    // daytime
                                    if(theme != 'light'){
                                        this.setTheme('light');
                                    }
                                }else{
                                    // nighttime
                                    if(theme != 'dark'){
                                        this.setTheme('dark');
                                    }
                                }
                            }
                            runThemeCheckOnce = true;
                        }
                    }catch(e){
                        console.error(e);
                    }
                }, 1000);
            }
        }catch(e){
            console.error(e);
        }
    },
    computed: {
        /**
         * Current project id from store or route.
         * @returns {string|null}
         */
        projectId(){
            return this.$store.state.project?.objectId || this.$route.params.projectId || null;
        },
        /**
         * First site the user can access in the current project (API order).
         * @returns {object|null}
         */
        firstSite(){
            return firstAccessibleSite(this.$store.state.sites, this.$store.state.user, this.projectId);
        },
        /**
         * Site id for site-scoped nav links: current accessible site, else the first accessible site.
         * @returns {string|null}
         */
        navSiteId(){
            const all = this.$store.state.sites || [];
            const accessible = sitesUserCanAccess(all, this.$store.state.user, this.projectId);
            const first = this.firstSite;
            const firstId = first ? (first.objectId || first.id) : null;
            const fromRoute = this.$route.params.siteId || this.$route.query.siteId;
            const fromApp = this.$store.state.appSiteId;
            if (all.length === 0) {
                return fromApp || this.siteId || fromRoute || firstId || null;
            }
            if (isAccessibleSiteId(fromApp, accessible)) return fromApp;
            if (isAccessibleSiteId(this.siteId, accessible)) return this.siteId;
            if (isAccessibleSiteId(fromRoute, accessible)) return fromRoute;
            return firstId;
        },
        /**
         * Query for project-level apps that support All Sites.
         * @returns {object}
         */
        appSiteQuery(){
            const siteId = this.$store.state.appSiteId;
            return siteId ? { siteId } : {};
        },
        /**
         * Fallback route while a site-scoped link has no site yet.
         * @returns {object}
         */
        homeTo(){
            return { path: '/' };
        },
        /**
         * Monitor Standard route (all-sites overview for the current project).
         * @returns {object}
         */
        monitorStandardTo(){
            if (!this.projectId) return this.homeTo;
            return { name: 'Project', params: { projectId: this.projectId } };
        },
        /**
         * Dashboards project-level route (All Sites).
         * @returns {object}
         */
        dashboardsTo(){
            if (!this.projectId) return this.homeTo;
            return { name: 'Dashboard', params: { projectId: this.projectId }, query: this.appSiteQuery };
        },
        /**
         * Heat Map route (first site when none is selected).
         * @returns {object}
         */
        heatMapTo(){
            if (!this.projectId || !this.navSiteId) return this.homeTo;
            return { path: `/projects/${this.projectId}/sites/${this.navSiteId}/heatmap` };
        },
        /**
         * Kiosks route (first site when none is selected).
         * @returns {object}
         */
        kiosksTo(){
            if (!this.navSiteId) return this.homeTo;
            return { path: '/kiosks', query: { siteId: this.navSiteId } };
        },
        /**
         * Devices project-level route (All Sites).
         * @returns {object}
         */
        devicesTo(){
            if (!this.projectId) return this.homeTo;
            return { path: `/projects/${this.projectId}/devices`, query: this.appSiteQuery };
        },
        /**
         * Reports route (first site when none is selected).
         * @returns {object}
         */
        reportsTo(){
            if (!this.projectId || !this.navSiteId) return this.homeTo;
            return { path: `/projects/${this.projectId}/sites/${this.navSiteId}/reports` };
        },
        /**
         * Alerts route (first site when none is selected).
         * @returns {object}
         */
        alertsTo(){
            if (!this.projectId || !this.navSiteId) return this.homeTo;
            return { path: `/projects/${this.projectId}/sites/${this.navSiteId}/alerts` };
        },
        /**
         * Schedules route (first site when none is selected).
         * @returns {object}
         */
        schedulesTo(){
            if (!this.projectId || !this.navSiteId) return this.homeTo;
            return { path: `/projects/${this.projectId}/sites/${this.navSiteId}/schedules` };
        },
        /**
         * Point Explorer project-level route (All Sites).
         * @returns {object}
         */
        pointExplorerTo(){
            if (!this.projectId) return this.homeTo;
            return { path: `/projects/${this.projectId}/pointexplorer`, query: this.appSiteQuery };
        },
        /**
         * Virtual Edge project-level route (All Sites).
         * @returns {object}
         */
        virtualEdgeTo(){
            if (!this.projectId) return this.homeTo;
            return { path: `/projects/${this.projectId}/virtualedge`, query: this.appSiteQuery };
        },
        /**
         * AI Chat project-level route (All Sites).
         * @returns {object}
         */
        aiChatTo(){
            if (!this.projectId) return this.homeTo;
            return { path: `/projects/${this.projectId}/aichat`, query: this.appSiteQuery };
        },
        /**
         * Library project-level route.
         * @returns {object}
         */
        libraryTo(){
            if (!this.projectId) return this.homeTo;
            return { path: `/projects/${this.projectId}/library`, query: this.appSiteQuery };
        },
        /**
         * True when Library should appear in the user menu.
         * @returns {boolean}
         */
        showLibraryNav(){
            return this.showAiChatNav;
        },
        /**
         * True when AI Chat should appear in the top/mobile nav.
         * @returns {boolean}
         */
        showAiChatNav(){
            if (!this.projectId) return false;
            if (!this.$store.getters.hasAtriumOrg) return false;
            const user = this.$store.state.user;
            if (!user) return false;
            const role = user.role || (user.attributes && user.attributes.role);
            return role === 'admin' || role === 'superAdmin';
        },
        userRole(){
            return this.$store.state.user?.role;
        },
        firstName(){
            return this.$store.state.user?.firstName;
        },
        lastName(){
            return this.$store.state.user?.lastName;
        },
        profilePhoto(){
            return this.$store.state.user?.profilePhoto?.url.replace('http://','https://');
        },
        projectThemes(){
            return this.$store.state.project?.themes;
        },
        currentTheme(){
            return this.$vuetify.theme.dark;
        },
        notifications() {
            return {
                alerts: this.$store.state.alerts,
                cssClass: this.$store.state.alertsCssClass
            }
        },
        /**
         * True when the current or first site supports schedules.
         * @returns {boolean}
         */
        canBeScheduled(){
            if (this.$store.state.site?.canBeScheduled == true || this.site?.canBeScheduled == true) return true;
            return this.firstSite?.canBeScheduled == true;
        },
        /**
         * True when Monitor dropdown should show as active.
         * @returns {boolean}
         */
        isMonitorGroupActive(){
            return this.tab === 'monitor' || this.tab === 'dashboard' || this.tab === 'heatmaps';
        }
    },
    watch: {
        /**
         * Keep the mobile Monitor group expanded on monitor-related tabs.
         * @param {boolean} open
         */
        drawer(open){
            if (open && this.isMonitorGroupActive) this.monitorGroupOpen = true;
        }
    }
};
</script>
<style lang="sass">
    .desktop-user-settings
        .v-list-item.h-divide
            min-height: 1px
            background: rgba(125, 133, 197, 0.2)
            height: 1px
            margin: 8px auto
            width: 80%
        .v-icon
            margin-right: 10px
    .desktop-nav-dropdown
        background-color: var(--app-secondary-bg)
        border-radius: 12px
        min-width: 180px
        .v-list
            background-color: var(--app-secondary-bg)
            padding: 8px 0
        .v-list-item
            color: var(--app-primary-txt)
            min-height: 40px
            &:hover
                background: rgba(0, 0, 0, 0.2)
            &.active
                color: var(--app-tertiary-txt)
                font-weight: 600
</style>
<style lang="sass" scoped>
    // TOP NAVBAR
    ::placeholder
        color: var(--input-txt)
    .icon-text
        color: var(--app-primary-txt)

    #navbar
        display: flex
        justify-content: space-around
        background-color: var(--app-secondary-bg)
        box-shadow: 0px 4px 4px 0px #00000040
        color: var(--app-tertiary-txt)
        width: 100%

        @media (min-width: 1904px)
            .desktop-nav,
            .mobile-nav
                // max-width: 1340px !important
                margin: 0 auto

        // SHARED NAV ITEMS
        ul
            padding-left: 0
        .default-logo
            max-height: 40px
    
        .h-divide
            background: rgba(125, 133, 197, 0.2)
            height: 1px
            margin: 8px auto
            width: 90%
        .v-divide
            background: rgba(125, 133, 197, 0.2)
            height: 40px
            margin: 0 40px 0 20px
            transform: matrix(-1, 0, 0, 1, 0, 0)
            width: 2px

        .nav-icons
            display: flex
            align-items: center
            flex-direction: row
            height: 56px
            .nav-icon
                cursor: pointer
                color: var(--navbar-theme-toggle)
                margin-left: 30px
            .v-icon
                height: 24px
                line-height: 24px
                &:focus
                    background: transparent
            .haq-alerts
                height: 24px
                width: 24px
                position: relative
                .v-icon
                    position: absolute
                .msmt-warning
                    color: var(--score-yellow-color)
                .msmt-critical
                    color: var(--score-red-color)
                .msmt-info
                    color: var(--score-blue-color)

        .avatar-wrapper
            display: flex
            align-items: center
            justify-content: center
            border-radius: 50px
            max-height: 44px
            max-width: 44px            
            overflow: hidden
            margin-left: 8px     
            &:hover
                background: transparent
            .avatar
                max-width: 44px
                min-width: 100%

        .user-role
            text-transform: capitalize

        // DESKTOP NAVIGATION
        .desktop-nav
            box-shadow: none
            display: flex
            align-items: center
            justify-content: space-between
            height: 64px
            padding: 0 20px 0 20px
            // max-width: 1340px!important
            
            section
                display: flex
                align-items: center
                justify-content: space-between
                height: 64px
                .logo
                    margin-right: 40px
                    display: flex
                    align-items: center
                    img
                        height: 50px
                ul.navigation
                    li
                        height: 64px
                        padding: 0 20px
                        text-align: center
                        &:hover
                            background: rgba(0, 0, 0, 0.1)
                        a
                            color: var(--app-tertiary-txt)
                            font-size: 20px
                            height: 64px
                            padding: 0
                            opacity: 0.6
                            text-transform: none
                            display: inline-flex
                            align-items: center
                            gap: 8px
                            &:hover
                                background: transparent
                        &.nav-dropdown
                            .v-menu
                                display: flex
                                height: 100%
                                align-items: center
                        .nav-dropdown-trigger
                            cursor: pointer
                        .nav-dropdown-caret
                            opacity: 0.8
                            margin-left: -2px
                        .nav-new-badge
                            display: inline-flex
                            align-items: center
                            justify-content: center
                            height: 18px
                            padding: 0 7px
                            border-radius: 4px
                            background: #0098ff
                            color: #fff
                            font-size: 10px
                            font-weight: 700
                            letter-spacing: 0.04em
                            text-transform: uppercase
                            opacity: 1
                            line-height: 1
                    li.active
                        background: transparent
                        border-bottom: 4px solid
                        border-bottom-color: var(--app-tertiary-txt)
                        &:hover
                            background: rgba(0, 0, 0, 0.1)
                        a
                            color: var(--app-tertiary-txt)
                            opacity: 1
            section.user-section
                display: flex
                align-items: center
                justify-content: space-between
                .user-info
                    text-align: right
                    .user-name
                        color: var(--app-primary-txt)
                        font-size: 16px
                        line-height: 24px
                    .user-role
                        color: var(--navbar-link-inactive)
                        font-size: 12px
                        line-height: 20px
                        font-weight: 300
                .user-img
                    img
                        margin-left: 16px
                    .dropdown-content,
                    .v-list
                        background-color: var(--app-secondary-bg)
                        border-radius: 12px
                        min-width:180px
                        top: 70px !important
                        .v-list-item
                            &:hover
                                background: rgba(0, 0, 0, 0.2)
                            a
                                color: var(--app-primary-txt)

        // MOBILE NAVIGATION
        .mobile-nav
            box-shadow: none
            display: flex
            align-items: center
            justify-content: space-between
            height: 56px
            padding: 0 15px
            
            section
                display: flex
                .mobile-drawer-trigger
                    font-size: 2.2rem
                    &:focus
                        &:after
                            background: transparent
                .logo 
                    height: 40px
                    img
                        height: 40px
        .mobile-drawer
            background-color: var(--app-secondary-bg)
            display: flex
            flex-direction: column
            height: 100vh
            padding-bottom: 0
            a
                color: var(--app-tertiary-txt)
                cursor: pointer
                font-size: 16px
                font-weight: 400
                display: inline-flex
                align-items: center
                gap: 8px
            .nav-new-badge
                display: inline-flex
                align-items: center
                justify-content: center
                height: 18px
                padding: 0 7px
                border-radius: 4px
                background: #0098ff
                color: #fff
                font-size: 10px
                font-weight: 700
                letter-spacing: 0.04em
                text-transform: uppercase
                line-height: 1

            .user-profile
                .user-img,
                .user-info
                    display: inline-block
                    vertical-align: middle
                .user-img,
                .user-img img
                    width: 50px !important
                    height: 50px !important
                    border-radius: 25px

                .user-info
                    .user-name
                        font-size: 18px
                        line-height: 24px
                    .user-role
                        color: var(--navbar-link-inactive)
                        font-size: 14px
                        line-height: 20px
                        font-weight: 300
</style>